/**
 * 📊 DATOS MAESTROS CENTRALIZADOS - LegalPlus
 * 
 * Este archivo contiene todas las opciones maestras del sistema
 * para evitar duplicación en múltiples componentes.
 * 
 * Importar donde sea necesario:
 * import { OPCIONES_CIERRE_MASTER, OPCIONES_TIPO_SERVICIO } from '../constants/masterData';
 */

// ===============================================================
// 1. OPCIONES DE CIERRE DE SERVICIO
// ===============================================================
export const OPCIONES_CIERRE_MASTER = [
  // IKE - Telefónico
  { id: 1011, label: 'TELEFONICO', grupo: 'IKE', tipo: 'TELEFONICO' },
  
  // IKE - Simple
  { id: 1021, label: 'SIMPLE', grupo: 'IKE', tipo: 'SIMPLE' },
  
  // IKE - Preliminar
  { id: 1031, label: 'SITIO (PRELIMINAR)', grupo: 'IKE', tipo: 'PRELIMINAR' },
  { id: 1032, label: 'LIBERACION (PRELIMINAR)', grupo: 'IKE', tipo: 'PRELIMINAR' },
  
  // IKE - Lesiones Desistidas
  { id: 1041, label: 'LESIONES DESISTIDAS', grupo: 'IKE', tipo: 'LESIONES_DESISTIDAS' },
  
  // IKE - Homicidio
  { id: 1051, label: 'SITIO (HOMICIDIO)', grupo: 'IKE', tipo: 'HOMICIDIO' },
  { id: 1052, label: 'ARRAIGO', grupo: 'IKE', tipo: 'HOMICIDIO' },
  { id: 1053, label: 'LIBERACION (HOMICIDIO)', grupo: 'IKE', tipo: 'HOMICIDIO' },
  
  // IKE - Audiencia
  { id: 1061, label: 'REALIZADA', grupo: 'IKE', tipo: 'AUDIENCIA' },
  { id: 1062, label: 'REPROGRAMADA', grupo: 'IKE', tipo: 'AUDIENCIA' },
  
  // ASIS - Telefónico
  { id: 2011, label: 'TELEFONICO', grupo: 'ASIS', tipo: 'TELEFONICO' },
  
  // ASIS - Simple
  { id: 2021, label: 'SIMPLE', grupo: 'ASIS', tipo: 'SIMPLE' },
  { id: 2022, label: 'FALLIDO', grupo: 'ASIS', tipo: 'SIMPLE' },
  
  // ASIS - Preliminar
  { id: 2031, label: 'SITIO (PRELIMINAR)', grupo: 'ASIS', tipo: 'PRELIMINAR' },
  { id: 2032, label: 'LIBERACION (PRELIMINAR)', grupo: 'ASIS', tipo: 'PRELIMINAR' },
  
  // ASIS - Lesiones Desistidas
  { id: 2041, label: 'LESIONES DESISTIDAS', grupo: 'ASIS', tipo: 'LESIONES_DESISTIDAS' },
  
  // ASIS - Homicidio
  { id: 2051, label: 'SITIO (HOMICIDIO)', grupo: 'ASIS', tipo: 'HOMICIDIO' },
  { id: 2052, label: 'ARRAIGO', grupo: 'ASIS', tipo: 'HOMICIDIO' },
  { id: 2053, label: 'LIBERACION (HOMICIDIO)', grupo: 'ASIS', tipo: 'HOMICIDIO' },
  
  // ASIS - Audiencia
  { id: 2061, label: 'REALIZADA', grupo: 'ASIS', tipo: 'AUDIENCIA' },
  { id: 2062, label: 'FALLIDO (AUDIENCIA)', grupo: 'ASIS', tipo: 'AUDIENCIA' },
  
  // Común - Cancelado
  { id: 999, label: 'CANCELADO', grupo: 'COMUN', tipo: 'CANCELADO' }
];

// ===============================================================
// 2. OPCIONES DE TIPO DE SERVICIO
// ===============================================================
export const OPCIONES_TIPO_SERVICIO = [
  { id: 101, label: 'TELEFONICO', grupo: 'IKE', categoria: 'telefonico' },
  { id: 102, label: 'SIMPLE', grupo: 'IKE', categoria: 'simple' },
  { id: 103, label: 'PRELIMINAR', grupo: 'IKE', categoria: 'preliminar' },
  { id: 104, label: 'LESIONES DESISTIDAS', grupo: 'IKE', categoria: 'lesiones' },
  { id: 105, label: 'HOMICIDIO', grupo: 'IKE', categoria: 'homicidio' },
  { id: 106, label: 'AUDIENCIA', grupo: 'IKE', categoria: 'audiencia' },
  { id: 201, label: 'TELEFONICO', grupo: 'ASIS', categoria: 'telefonico' },
  { id: 202, label: 'SIMPLE', grupo: 'ASIS', categoria: 'simple' },
  { id: 203, label: 'PRELIMINAR', grupo: 'ASIS', categoria: 'preliminar' },
  { id: 204, label: 'LESIONES DESISTIDAS', grupo: 'ASIS', categoria: 'lesiones' },
  { id: 205, label: 'HOMICIDIO', grupo: 'ASIS', categoria: 'homicidio' },
  { id: 206, label: 'AUDIENCIA', grupo: 'ASIS', categoria: 'audiencia' },
  { id: 999, label: 'CANCELADO', grupo: 'COMUN', categoria: 'cancelado' }
];

// ===============================================================
// 3. OPCIONES DE RESPONSABILIDAD
// ===============================================================
export const OPCIONES_RESPONSABILIDAD = [
  { id: 11, label: 'ASEGURADO', grupo: 'IKE' },
  { id: 12, label: 'TERCERO', grupo: 'IKE' },
  { id: 13, label: 'INDETERMINADA', grupo: 'IKE' },
  { id: 14, label: 'COMPARTIDA', grupo: 'IKE' },
  { id: 21, label: 'ASEGURADO', grupo: 'ASIS' },
  { id: 22, label: 'TERCERO', grupo: 'ASIS' },
  { id: 23, label: 'INDETERMINADA', grupo: 'ASIS' },
  { id: 24, label: 'COMPARTIDA', grupo: 'ASIS' }
];

// ===============================================================
// 4. OPCIONES DE CHOQUE SIMPLE
// ===============================================================
export const OPCIONES_CHOQUE_SIMPLE = [
  { id: 10211, label: 'LEY 2251 DE 2022', grupo: 'IKE' },
  { id: 10212, label: 'POLIZA A FAVOR DEL ASEGURADO', grupo: 'IKE' },
  { id: 10213, label: 'POLIZA A FAVOR DEL TERCERO', grupo: 'IKE' },
  { id: 10214, label: 'ARREGLO DIRECTO', grupo: 'IKE' },
  { id: 10215, label: 'CONTRATO DEDUCIBLE', grupo: 'IKE' },
  { id: 10216, label: 'ASUMIR DAÑOS', grupo: 'IKE' },
  { id: 20211, label: 'LEY 2251 DE 2022', grupo: 'ASIS' },
  { id: 20212, label: 'POLIZA A FAVOR DEL ASEGURADO', grupo: 'ASIS' },
  { id: 20213, label: 'POLIZA A FAVOR DEL TERCERO', grupo: 'ASIS' },
  { id: 20214, label: 'ARREGLO DIRECTO', grupo: 'ASIS' },
  { id: 20215, label: 'CONTRATO DEDUCIBLE', grupo: 'ASIS' },
  { id: 20216, label: 'ASUMIR DAÑOS', grupo: 'ASIS' }
];

// ===============================================================
// FUNCIONES HELPER PARA TRABAJAR CON LOS DATOS
// ===============================================================

/**
 * Filtra opciones de cierre por grupo (IKE, ASIS, o ambos)
 * @param {string} grupo - 'IKE', 'ASIS', o 'COMUN'
 * @returns {Array}
 */
export const getOpcionesCierrePorGrupo = (grupo) => {
  if (!grupo) return OPCIONES_CIERRE_MASTER;
  
  const grupoUpper = grupo.toUpperCase();
  
  if (grupoUpper.includes('IKE')) {
    return OPCIONES_CIERRE_MASTER.filter(opt => 
      opt.grupo === 'IKE' || opt.grupo === 'COMUN'
    );
  }
  
  if (grupoUpper.includes('ASIS') || grupoUpper.includes('SPREX')) {
    return OPCIONES_CIERRE_MASTER.filter(opt => 
      opt.grupo === 'ASIS' || opt.grupo === 'COMUN'
    );
  }
  
  return OPCIONES_CIERRE_MASTER;
};

/**
 * Obtiene el label de una opción de cierre por ID
 * @param {number} id
 * @returns {string}
 */
export const getLabelCierre = (id) => {
  const opcion = OPCIONES_CIERRE_MASTER.find(opt => opt.id === parseInt(id));
  return opcion ? opcion.label : 'DESCONOCIDO';
};

/**
 * Obtiene el label de un tipo de servicio por ID
 * @param {number} id
 * @returns {string}
 */
export const getLabelTipoServicio = (id) => {
  const opcion = OPCIONES_TIPO_SERVICIO.find(opt => opt.id === parseInt(id));
  return opcion ? opcion.label : 'DESCONOCIDO';
};

/**
 * Determina el grupo (IKE/ASIS) basado en el nombre del cliente
 * @param {string} cliente - Nombre del cliente
 * @returns {string} 'IKE' o 'ASIS'
 */
export const getGrupoCliente = (cliente) => {
  if (!cliente) return 'IKE';
  
  const clienteUpper = cliente.toUpperCase();
  
  if (clienteUpper.includes('ASIS') || clienteUpper.includes('SPREX')) {
    return 'ASIS';
  }
  
  return 'IKE';
};

/**
 * Filtra opciones de tipo de servicio por grupo
 * @param {string} grupo - 'IKE' o 'ASIS'
 * @returns {Array}
 */
export const getOpcionesTipoServicioPorGrupo = (grupo) => {
  if (!grupo) return OPCIONES_TIPO_SERVICIO;
  
  const grupoUpper = grupo.toUpperCase();
  
  return OPCIONES_TIPO_SERVICIO.filter(opt => 
    opt.grupo === grupoUpper || opt.grupo === 'COMUN'
  );
};

/**
 * Filtra opciones de responsabilidad por grupo
 * @param {string} grupo - 'IKE' o 'ASIS'
 * @returns {Array}
 */
export const getOpcionesResponsabilidadPorGrupo = (grupo) => {
  if (!grupo) return OPCIONES_RESPONSABILIDAD;
  
  const grupoUpper = grupo.toUpperCase();
  
  return OPCIONES_RESPONSABILIDAD.filter(opt => opt.grupo === grupoUpper);
};

/**
 * Filtra opciones de choque simple por grupo
 * @param {string} grupo - 'IKE' o 'ASIS'
 * @returns {Array}
 */
export const getOpcionesChoqueSimplePorGrupo = (grupo) => {
  if (!grupo) return OPCIONES_CHOQUE_SIMPLE;
  
  const grupoUpper = grupo.toUpperCase();
  
  return OPCIONES_CHOQUE_SIMPLE.filter(opt => opt.grupo === grupoUpper);
};

// ===============================================================
// CONSTANTES DE ESTADO Y COLORES
// ===============================================================

/**
 * Mapeo de estados a colores para UI
 */
export const ESTADO_COLORES = {
  exitoso: 'bg-green-900 text-green-300',
  completado: 'bg-green-900 text-green-300',
  realizada: 'bg-green-900 text-green-300',
  simple: 'bg-green-900 text-green-300',
  cancelado: 'bg-red-900 text-red-300',
  rechazado: 'bg-red-900 text-red-300',
  fallido: 'bg-red-900 text-red-300',
  pendiente: 'bg-yellow-900 text-yellow-300',
  proceso: 'bg-yellow-900 text-yellow-300',
  sitio: 'bg-yellow-900 text-yellow-300',
  preliminar: 'bg-yellow-900 text-yellow-300',
  default: 'bg-blue-900 text-blue-300'
};

/**
 * Obtiene la clase de color según el estado
 * @param {string} status
 * @returns {string} Clase de Tailwind
 */
export const getStatusColor = (status) => {
  if (!status) return ESTADO_COLORES.default;
  
  const lowerStatus = String(status).toLowerCase();
  
  for (const [key, color] of Object.entries(ESTADO_COLORES)) {
    if (key !== 'default' && lowerStatus.includes(key)) {
      return color;
    }
  }
  
  return ESTADO_COLORES.default;
};

// ===============================================================
// EXPORT DEFAULT
// ===============================================================

const masterData = {
  OPCIONES_CIERRE_MASTER,
  OPCIONES_TIPO_SERVICIO,
  OPCIONES_RESPONSABILIDAD,
  OPCIONES_CHOQUE_SIMPLE,
  getOpcionesCierrePorGrupo,
  getLabelCierre,
  getLabelTipoServicio,
  getGrupoCliente,
  getOpcionesTipoServicioPorGrupo,
  getOpcionesResponsabilidadPorGrupo,
  getOpcionesChoqueSimplePorGrupo,
  ESTADO_COLORES,
  getStatusColor
};

export default masterData;
